import { fetchConToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./auth";

export const cmpStartLoading = (id) => {

    return async(dispatch) => {

        try {
            const resp = await fetchConToken(`cmp/`);
            const body = await resp.json();
            if ( resp.status === 200 && body) {
                dispatch(cmpLoaded(body));
            } else if (body?.token === false) {
                dispatch(startLogout());
            }
        } catch (error) {
            console.log(error);
        }
    }
}

const cmpLoaded = (cmpData) => ({
    type: types.cmpLoaded,
    payload: cmpData
});

export const filterCmp = (data) => {

    return async(dispatch) => {

        try {
            const resp = await fetchConToken(`cmp`, data);
            const body = await resp.json();
            if (resp.status === 200 && body) {
                dispatch(cmpLoaded(body));
            } else if (body?.token === false) {
                dispatch(startLogout());
            }
        } catch (error) {
            console.log(error);
        }
    }
}